var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemUpdates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M19.243 10.015c-.625.007-1.127.514-1.12 1.133v.009c0 4.345-3.534 7.842-7.927 7.842-2.1 0-4.071-.83-5.533-2.241h2.129c.626 0 1.134-.503 1.134-1.122 0-.62-.508-1.122-1.134-1.122H2.269c-.625-.002-1.134.498-1.137 1.117v4.484c-.013.618.483 1.13 1.108 1.144.626.014 1.144-.477 1.158-1.096V18.66c1.845 1.632 4.253 2.58 6.798 2.58 5.617 0 10.193-4.526 10.193-10.082.012-.618-.484-1.13-1.11-1.142h-.036z",
    transform: "translate(.32 .151)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M18.106 0c-.626.012-1.123.524-1.11 1.142v1.463c-1.844-1.638-4.25-2.59-6.8-2.59C4.58.015.005 4.552.005 10.11c-.054.616.408 1.159 1.03 1.212.624.053 1.173-.404 1.227-1.02.005-.064.005-.128 0-.192 0-4.345 3.543-7.85 7.936-7.85 2.1 0 4.07.829 5.53 2.241h-2.136c-.626-.014-1.144.477-1.158 1.096-.013.62.484 1.131 1.11 1.145h4.581c.625.002 1.134-.498 1.137-1.116V1.143c.012-.62-.485-1.13-1.11-1.143h-.045z",
    transform: "translate(.32 .151)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUpdates);
export default __webpack_public_path__ + "static/media/system_updates.6b74f0a4c3bc2c74fc7b149b09277c98.svg";
export { ForwardRef as ReactComponent };